import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    save: {
        data: {}
    },
    table: createTableState(),
    filterData: undefined
})

// getters
const getters = {
    showData: (state) => state.save.data,
}

// actions
const actions = {
    // get records
    async get({state, commit, rootState}, {page, filterData} = {}) {
        commit('setLoading', true)
        commit('updateTableData', [])

        const selectedCompany = rootState.company.authorized.selectCompany

        state.filterData = filterData;

        let params = {
            page: page?.current ?? 1,
            page_limit: page?.pageSize ?? 10,
            company_id: selectedCompany,
        };

        if(state.filterData){
            params = {...params, ...state.filterData};
        }

        const res = await this._vm.axios.get(this._vm.endpoints['module_vehicle_work_order'], {
            params: params
        })

        const {data, meta} = res.data
        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    //  show record
    async show({commit, dispatch, rootState}, {id}) {
        commit('setLoading', true)
        commit('updateSaveData', {})

        const res = await this._vm.axios.get( this._vm.endpoints['module_vehicle_work_order'] + '/' + id );
        if (res.status) {
            const {data} = res.data
            commit('updateSaveData', data)
        } else {
            this._vm.$message.error(res.message)
        }

        commit('setLoading', false)
    },

    //  show record
    async add({commit, dispatch, rootState}, {formData}) {
        commit('setLoading', true)

        try {
            const selectedCompany = rootState.company.authorized.selectCompany
            const payload = {
                company_id: selectedCompany,
                company_customer_id: formData.company_customer_id ?? null,
                customer_vehicle_id: formData.customer_vehicle_id ?? null,
                type_id: formData.type_id ?? null,
                price_type_id: formData.price_type_id ?? 1,
                status_id: formData.status_id ?? null,
                odometer: formData.odometer ?? null,
                complaint: formData.complaint ?? null,
                diagnosis: formData.diagnosis ?? null,
                items: formData.items ?? null,
                total_paid: formData.total_paid ?? null,
                payment_method_id: formData.payment_method_id ?? null,
            };
            // ORDER_BASED (price_type_id=2): backend data.total_amount okur.
            // ITEM_BASED'de tutar items.sum'dan hesaplanir, gonderilmez.
            if (Number(formData.price_type_id) === 2) {
                payload.total_amount = formData.total_price ?? 0;
            }
            if (!formData.company_customer_id) {
                payload.customer = {
                    firstname: formData.company_customer.firstname ?? null,
                    lastname: formData.company_customer.lastname ?? null,
                    mobile_phone: formData.company_customer.mobile_phone ?? null,
                };

                if (!formData.customer_vehicle_id) {
                    payload.customer.vehicle = {
                        plate: formData.company_customer.vehicle.plate ?? null,
                        model_id: formData.company_customer.vehicle.model_id ?? null,
                        year_id: formData.company_customer.vehicle.year_id ?? null,
                    };
                }
            } else if (!formData.customer_vehicle_id) {
                payload.customer = {
                    vehicle: {
                        plate: formData.company_customer.vehicle.plate ?? null,
                        model_id: formData.company_customer.vehicle.model_id ?? null,
                        year_id: formData.company_customer.vehicle.year_id ?? null,
                    }
                };
            }

            const res = await this._vm.axios.post(this._vm.endpoints['module_vehicle_work_order'], payload);

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    // update record
    async update({commit, dispatch, rootState}, {id, formData}) {
        commit('setLoading', true)

        try {
            // Backend VWO update kontrati total_paid beklemiyor (edit modunda
            // odeme PaymentPanel/transaction uzerinden yonetilir).
            const updatePayload = {
                type_id: formData.type_id ?? null,
                price_type_id: formData.price_type_id ?? 1,
                status_id: formData.status_id ?? null,
                odometer: formData.odometer ?? null,
                complaint: formData.complaint ?? null,
                diagnosis: formData.diagnosis ?? null,
            };
            // ORDER_BASED (price_type_id=2): backend data.total_amount okur.
            // ITEM_BASED'de tutar items uzerinden otomatik guncellenir.
            if (Number(formData.price_type_id) === 2) {
                updatePayload.total_amount = formData.total_price ?? 0;
            }
            const res = await this._vm.axios.put(
                this._vm.endpoints['module_vehicle_work_order'] + '/' + id,
                updatePayload
            )

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    // change status record
    async changeStatus({commit, dispatch, rootState}, {id, status_id}) {
        try {
            const res = await this._vm.axios.patch(
                this._vm.endpoints['module_vehicle_work_order_status'],
                { status_id },
                { urlVars: { id } }
            )

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        }
    },

    //  delete record
    async delete({commit, dispatch}, {id}) {
        let successDeleted = [];
        if (id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoints['module_vehicle_work_order'] + '/' + id[i]);
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'));
                    successDeleted.push(id[i]);
                } else {
                    this._vm.$message.error(data.message)
                }
            }

            dispatch('refresh')

            return successDeleted;
        }
    },

    // refresh records
    refresh({dispatch}) {
        dispatch('get');
    }
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateSaveData(state, data) {
        state.save.data = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
